module.exports = __webpack_public_path__ + "static/media/L.8227938a.jpg";